import React from "react";
import { AppCardHeader, AppCardTitle } from "../Generic/AppCard";

interface Props {
  title: string;
}

function OnboardingSectionAppCardHeader(props: Props) {
  if (props.title === "") {
    return <></>;
  }

  return (
    <AppCardHeader>
      <AppCardTitle>{props.title}</AppCardTitle>
    </AppCardHeader>
  );
}

export default OnboardingSectionAppCardHeader;
